// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const MarketingDataDocument = `
    mutation marketingData($input: MarketingDataInput!) {
  marketingData(input: $input) {
    success
  }
}
    `;

export function useMarketingDataMutation() {
  return Urql.useMutation<SchemaTypes.MarketingDataMutation, SchemaTypes.MarketingDataMutationVariables>(MarketingDataDocument);
};